import { Component, OnInit, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import jspdf from 'jspdf';
import html2canvas from 'html2canvas';

import { ARService } from '../../ar.service';
import { dataARPaymentPlan, dataARLedger, dataARPaymentPlanItem } from '../../_models/ar.models';
import { ArCardPaymentComponent } from '../../payment/ar-card-payment/ar-card-payment.component';

@Component({
  selector: 'app-plan-view',
  templateUrl: './plan-view.component.html',
  styleUrls: ['./plan-view.component.css']
})
export class PlanViewComponent implements OnInit {

  readOnly: boolean = false;
  isLoading: boolean = false;
  generatingPdf: boolean = false;
  paymentPlanId: string = '';
  paymentPlan: dataARPaymentPlan;
  invoiceGuids: string[] = [];
  hasUnpaidItems: boolean = false;
  paymentIsDue: boolean = false;

  dataInvoiceItem: any = {
    columns: [
      { title: 'Service', key: 'serviceName', show: true, pipe: 'trim' },
      { title: 'Code', key: 'serviceCode', show: true, pipe: 'none' },
      { title: 'Rate', key: 'servicePrice', show: true, pipe: 'currency' },
    ],
    paymentColumns: [
      { title: 'Date', key: 'paymentDate', show: true, pipe: 'date' },
      { title: 'Amount', key: 'paymentAmount', show: true, pipe: 'currency' },
      { title: 'Status', key: 'paymentStatus', show: true, pipe: 'none' },
    ],
    billableItems: [
      {
        serviceName: 'Test Procedure',
        serviceCode: 'D0123',
        servicePrice: '123',
        showItem: true,
      }
    ],
    paymentItems: [
      {
        paymentDate: new Date(),
        paymentAmount: 123,
        paymentStatus: 'Unpaid',
        showItem: true,
      }
    ],
    totalDue: 0,
  };

  enumCoverageCalcTypePercent: string = '00000048-1000-0000-0000-000000000001';
  enumCoverageCalcTypeAmount: string = '00000048-1000-0000-0000-000000000002';
  enumPaymentPlanStatusPaid: string = '00000095-1000-0000-0000-000000000004';

  constructor(
    private arService: ARService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<PlanViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.paymentPlanId = this.data.paymentPlanId;
    this.paymentPlan = this.data.paymentPlan;
    this.init();
  }

  async init() {

    this.isLoading = true;
    console.log(this.paymentPlan);

    this.invoiceGuids = await this.getNewGuids();

    this.paymentPlan.dataARPaymentPlanItems = this.paymentPlan.dataARPaymentPlanItems.sort((a, b) => {
      let d1 = new Date(a.DueDate);
      let d2 = new Date(b.DueDate);
      return d1.getTime() - d2.getTime();
    });

    this.mapPaymentPlan(this.paymentPlan);
    this.hasUnpaidItems = this.paymentPlan.dataARPaymentPlanItems.filter(item => { return item.enumPaymentPlanItemStatusID !== this.enumPaymentPlanStatusPaid }).length > 0;

    if (!this.hasUnpaidItems && this.paymentPlan.enumPaymentPlanStatusID !== this.enumPaymentPlanStatusPaid) {
      this.paymentPlan.enumPaymentPlanStatusID = this.enumPaymentPlanStatusPaid;
      let planClone: dataARPaymentPlan = JSON.parse(JSON.stringify(this.paymentPlan));
      planClone.dataARPaymentPlanItems = [];
      planClone.dataARPaymentPlanLedgerItems = [];

      try {
        await this.arService.savePaymentPlan(planClone).toPromise();
      } catch (err) {
        console.log(err);
        this.createMessage("Something went wrong", "Error");  
      }

    }

    if (this.hasUnpaidItems) {

      let soonestPaymentItem = this.paymentPlan.dataARPaymentPlanItems.find(item => {
        return item.enumPaymentPlanItemStatusID !== this.enumPaymentPlanStatusPaid;
      });

      let now = new Date().getTime();
      let paymentDueDate = new Date(soonestPaymentItem.DueDate).getTime();
      let threeDaysInMilliseconds = 1000 * 60 * 60 * 24 * 3;

      if (paymentDueDate <= now || (paymentDueDate - now) <= threeDaysInMilliseconds) {
        this.paymentIsDue = true;
      } else {
        this.paymentIsDue = false;
      }

    }

    this.isLoading = false;
  }

  mapPaymentPlan(paymentPlan: dataARPaymentPlan) {

    this.dataInvoiceItem = {
      columns: [
        { title: 'Service', key: 'serviceName', show: true, pipe: 'trim' },
        { title: 'Code', key: 'serviceCode', show: true, pipe: 'none' },
        { title: 'Rate', key: 'servicePrice', show: true, pipe: 'currency' },
      ],
      paymentColumns: [
        { title: 'Date', key: 'paymentDate', show: true, pipe: 'date' },
        { title: 'Amount', key: 'paymentAmount', show: true, pipe: 'currency' },
        { title: 'Status', key: 'paymentStatus', show: true, pipe: 'none' },
      ],
      billableItems: [],
      paymentItems: [],
      totalDue: 0,
    };

    this.dataInvoiceItem.totalDue = paymentPlan.TotalAmount;
    this.dataInvoiceItem.billableItems = paymentPlan.dataARPaymentPlanLedgerItems.map(item => {
      console.log('ITEM', item);
      var adjustedPrice = this.calcAdjustedPrice(item.dataARLedger);
      let obj = {
        serviceName: this.trimName(item.dataARLedger.dataARTransactionItem.dataPatientCaseWorkItem.cfgCaseProcedure.Description),
        serviceCode: item.dataARLedger.dataARTransactionItem.Code,
        servicePrice: adjustedPrice,
        showItem: true,
      }
      return obj;
    });
    this.dataInvoiceItem.paymentItems = paymentPlan.dataARPaymentPlanItems.map(item => {
      let obj = {
        paymentDate: item.DueDate,
        paymentAmount: item.Amount,
        paymentStatus: item.enumPaymentPlanItemStatusID === this.enumPaymentPlanStatusPaid ? 'Paid' : 'Unpaid',
        showItem: true,
      };
      return obj;
    });
  }

  trimName(name: string) {
    if (name && name.length > 20) {
      return name.slice(0, 20);
    }
    return name;
  }

  calcAdjustedPrice(ledgerItem: dataARLedger) {
    let enumCoverageTypePCT: string = '00000048-1000-0000-0000-000000000001';
    let enumCoverageTypeAmount: string = '00000048-1000-0000-0000-000000000002';

    if (!ledgerItem.dataARTransactionItem) {
      return ledgerItem.Amount;
    }

    if (ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId === enumCoverageTypePCT) {
      if (ledgerItem.dataARTransactionItem.DiscountPCT == null || typeof ledgerItem.dataARTransactionItem.DiscountPCT == "undefined") {
        return ledgerItem.Amount;
      } else {
        return ledgerItem.Amount * ((ledgerItem.dataARTransactionItem.DiscountPCT) / 100);
      }
    }

    if (ledgerItem.dataARTransactionItem.enumFeeDiscountCalcTypeId === enumCoverageTypeAmount) {
      if (ledgerItem.dataARTransactionItem.DiscountAmount == null || typeof ledgerItem.dataARTransactionItem.DiscountAmount == "undefined") {
        return ledgerItem.Amount;
      } else {
        return ledgerItem.Amount - ledgerItem.dataARTransactionItem.DiscountAmount;
      }
    }

    return ledgerItem.Amount;
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  async approvePlan() {
    this.paymentPlan.AcceptedDate = new Date();
    this.paymentPlan.isPatientAccepted = true;
    this.isLoading = true;

    try {
      let planClone: dataARPaymentPlan = JSON.parse(JSON.stringify(this.paymentPlan));
      planClone.dataARPaymentPlanItems = [];
      planClone.dataARPaymentPlanLedgerItems = [];
      await this.arService.savePaymentPlan(planClone).toPromise();
    } catch (err) {
      console.log(err);
      this.createMessage("Something went wrong", "Error");  
    }

    this.isLoading = false;
    this.close(true);
  }

  generatePDF() {

    // need to split up the form into pages
    // need to limit the width or scroll out so that it fits
    // need to auto scroll to next section 

    this.generatingPdf = true;

    setTimeout(_ => {
      html2canvas(document.querySelector("#main-plan-container")).then(canvas => {

        var imgData = canvas.toDataURL('image/png');
        var imgWidth = 210;
        var pageHeight = 295;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;
        var doc = new jspdf('p', 'mm');
        var position = 10; // give some top padding to first page

        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position += heightLeft - imgHeight; // top padding for other pages
          doc.addPage();
          doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        doc.save(`PaymentPlan.pdf`);

        this.generatingPdf = false;

      });
    }, 2000);
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: "top"
    });
  }

  getNewGuids(): any {
    let promise = new Promise((resolve, reject) => {
      this.arService.getNewNonSequentialGuids()
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  stagePaymentForLedgerItem(paymentItem: any) {
    let promise = new Promise((resolve, reject) => {
      this.arService.stagePaymentForLedgerItem(paymentItem)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  async makePayment() {

    let paymentItem = this.paymentPlan.dataARPaymentPlanItems.find(item => {
      return item.enumPaymentPlanItemStatusID !== this.enumPaymentPlanStatusPaid;
    });

    console.log('------------------');
    console.log('paymentItem', paymentItem);

    this.paymentPlan.dataARPaymentPlanLedgerItems = this.paymentPlan.dataARPaymentPlanLedgerItems.sort((a, b) => {
      let d1 = new Date(a.xauditCreatedOn);
      let d2 = new Date(b.xauditCreatedOn);
      return d1.getTime() - d2.getTime();
    });

    let paymentAmount: number = paymentItem.Amount;

    let previousPayments: any[] = this.paymentPlan.dataARPaymentPlanLedgerItems.map(item => {
      let previousPayment = 0;
      item.dataARLedger.dataARPaymentDistribs.forEach(distrib => {
        previousPayment += distrib.Amount;
      });
      return {
        LedgerID: item.dataARLedger.LedgerID,
        previousPayments: item.dataARLedger.dataARPaymentDistribs.map(distrib => {
          return distrib.Amount;
        }),
        previousPayment: previousPayment,
        Amount: item.dataARLedger.Amount,
        LedgerItem: item.dataARLedger,
        remove: false,
        amountToCharge: 0
      };
    });

    console.log('previousPayments', previousPayments);
    
    previousPayments.forEach(item => {
      if (paymentAmount === 0 || (item.Amount - item.previousPayment) <= 0) {
        item.remove = true;
      } else if (paymentAmount >= (item.Amount - item.previousPayment)) {
        paymentAmount -= (item.LedgerItem.Amount - item.previousPayment);
        item.amountToCharge = item.LedgerItem.Amount;
      } else {
        item.amountToCharge = paymentAmount;
        paymentAmount = 0;        
      }
    });

    previousPayments = previousPayments.filter(item => {
      return !item.remove;
    });

    console.log('previousPayments', previousPayments);

    if (!previousPayments.length) {
      console.log('ending early, nothing to pay');
      this.close(true);
      return;
    }

    let obj = {
      Description: "Plan Payment",
      InvoiceId: this.invoiceGuids.splice(0, 1)[0],
      enumPayementTypeID: "",
      enumPaymentSourceID: "",
      ledgerItems: previousPayments.map(payment => { return payment.LedgerItem; }),
      ledgerPayments: previousPayments.map(payment => {
        return {
          LedgerID: payment.LedgerID,
          paymentAmount: payment.amountToCharge,
        }
      }),
      paymentAmount: paymentItem.Amount,
    };

    console.log('obj', obj);

    try {
      let stagingItem: any = await this.stagePaymentForLedgerItem(obj);
      console.log('staging these!', stagingItem);
      let result = await this.openCardPaymentComponent(stagingItem, obj.paymentAmount, obj.InvoiceId);
      console.log(result);

      let isPaid = await this.checkForPaymentCompletedByWP(stagingItem.PaymetnID);
      console.log('is paid', isPaid);

      // after every 'is paid' you should make sure that every ledger item is good

      if (paymentItem) {
        paymentItem.enumPaymentPlanItemStatusID = this.enumPaymentPlanStatusPaid;
        let paymentItemClone: dataARPaymentPlanItem = JSON.parse(JSON.stringify(paymentItem));
        await this.arService.savePaymentPlanItem(paymentItemClone).toPromise();
      }

      this.close(true);      
      // check if the payment was paid
      // if so, mark the items paid as paid if they are paid in full
      // then exit and tell the main page to refresh
      // have to mark plan item as complete

    } catch (err) {
      console.log('err', err);
      this.createMessage("Something went wrong", "Error");  
    }

  }

  openCardPaymentComponent(stagingItem: any, paymentAmount: number, invoiceId: string) {
    let promise = new Promise((resolve, reject) => {

      //var paymentObjs = this.distributePayment();

      //if (paymentObjs.length == 0) {
      //  reject('no payment objs');
      //}

      var LOCID = JSON.parse(localStorage.getItem('storedPatient')).TDOCID;

      const dialogRef = this.dialog.open(ArCardPaymentComponent, {
        width: '90%',
        height: '90%',
        disableClose: true,
        data: {
          paymentAmount: paymentAmount,
          stagingItem: stagingItem,
          invoiceId: invoiceId,
          LOCID: LOCID,
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        resolve(result);
      }, err => {
        resolve(false);
      });

    });
    return promise;
  }  

  checkForPaymentCompletedByWP(paymentId) {
    let promise = new Promise((resolve, reject) => {
      this.arService.checkForPaymentCompletedByWP(paymentId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

}

/*
 * Here we will view the details of a specific plan, can open the create window to edit the plan
 * can view the payment progress of the plan
 */
